import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  FormControlLabel,
  Grid,
  Paper,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import { exportExcelConsumosAfiliado, getConsumosAfiliado } from "../../../../actions/autorizaciones/Autorizaciones";
import IconEstado from "../../../autorizaciones/UI/IconEstado";
import { TableToolbarExportAndPrint } from "../../../turnos/recepcionDiaria/TableToolbarExportAndPrint";
import moment from "moment";
import { types } from "../../../../types/types";

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

const TabsAutorizacion = (props) => {
  const dispatch = useDispatch();

  const { consumosAfiliado: items } = useSelector( (state) => state.autorizaciones );

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [dense, setDense] = useState(true);

  useEffect(() => {
    dispatch({
      type: types.autorizacionesClearConsumosAfiliado,
    });
    dispatch( getConsumosAfiliado(props.afiliado.id_afiliado) );
  }, [dispatch]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportExcel = () => {
    dispatch(
      exportExcelConsumosAfiliado(
        props.afiliado.id_afiliado,
        props.afiliado.carnet,
        moment().format("YYYYMMDD")
      )
    );
  };

  return (
      <>
        {Array.isArray(items) &&
        items?.length > 0 ? (
          <TableContainer component={Paper} style={{ overflowX: "auto" }}>
            <Table size={dense ? "small" : "medium"}>
              <TableHead>
                <TableRow>
                  <TableCell>Estado</TableCell>
                  <TableCell>Solicitud</TableCell>
                  <TableCell>Fecha Solicitud</TableCell>
                  <TableCell>Codigo</TableCell>
                  <TableCell>Práctica</TableCell>
                  <TableCell>Efector Institucional</TableCell>
                  <TableCell>Diagnóstico</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((solicitud) => {
                    return (
                      <TableRow key={solicitud?.idSolicitud}>
                        <TableCell>
                            <IconEstado
                                useColorTable={true}
                                texto={solicitud?.letraEstado}
                                backgroundColor={solicitud?.colorEstado}
                                descripcion={solicitud?.descripcionEstado}
                            />
                        </TableCell>
                        <TableCell>{solicitud?.idSolicitud}</TableCell>
                        <TableCell>
                          {new Date(solicitud?.fecha).toLocaleString(
                            "es",
                            optionsfecha
                          )}
                        </TableCell>
                        <TableCell>{solicitud?.codNomPlano}</TableCell>
                        <TableCell>{solicitud?.practica}</TableCell>
                        <TableCell>{solicitud?.efectorInstitucional}</TableCell>
                        <TableCell>{solicitud?.diagnostico ? solicitud?.diagnostico : solicitud?.desc_Diag}</TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography style={{ fontStyle: "italic", fontSize: "1.1rem" }}>
            No hay datos
          </Typography>
        )}
        {items?.length > 0 && (
          <Grid item xs={12}>
            <TablePagination
              style={{ backgroundColor: "white" }}
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={items.length}
              rowsPerPage={rowsPerPage}
              labelRowsPerPage="Registros por página"
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={dense}
                  onChange={(e) => setDense(e.target.checked)}
                />
              }
              label="Tamaño compacto"
            />
            <TableToolbarExportAndPrint
              cargada={items?.length > 0}
              handleExportExcel={handleExportExcel}
            />
          </Grid>
        )}
  </>
  );
};

export default TabsAutorizacion;
